module.exports = {"attributes":{"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M31 4L29 35.5H22L20 4H31Z\" fill=\"#558EFF\"/> <path d=\"M21.5 40.5H29.5V45.5H21.5V40.5Z\" fill=\"#558EFF\"/>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/channel/dummy.svg
// module id = 1295
// module chunks = 0